import Dialog from 'components/Dialog';
import { useLanguage } from 'context/AppContext';

type Props = {
  onConfirm?: () => void;
  onCancel?: () => void;
  onExit?: () => void;
};

export const ConfirmDecantTrayDialog = ({ onConfirm, onCancel, onExit }: Props) => {
  const lang = useLanguage()[0].ConfirmDecantTrayDialog;

  return (
    <Dialog
      open
      title={lang.title}
      confirmLabel={lang.confirm}
      cancelLabel={lang.cancel}
      allowClose={!!onExit}
      onClose={onExit}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
